<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Total Marketcap" more="/staking" :help="help1" :secondline="$options.filters.toInt(totalMarketcapETH, 0, 'ETH')" color="#07D3DA">{{ totalMarketcapUSD | toCurrency(0, "USD")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Total Minted Supply" more="/price" :help="help2" color="#C6362F">{{ totalSupply | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="ROI on initial price" more="/price" :help="help3" :secondline="'ETH: ' + $options.filters.toInt(roiETH, 2, '%')" color="#BDD358">USD: {{ roiUSD | toInt(2, "%")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Uniswap Liquidity/Rank" :secondline="'Rank ' + currentLiquidityRank" more="/staking" :help="help4" color="#E28413">{{ currentLiquidityUSD | toCurrency(0, "USD") }}</NumberCard>
      </v-col>
    </v-row>

    <PriceWidgetStaking class="mt-8"/>

    <v-row class="">
      <v-col cols="12" md="6" lg="4">
        <DataCard title="Market Data USD" :data="marketUSDArray"></DataCard>
        <DataCard title="Market Data ETH" :data="marketETHArray"></DataCard>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <DataCard title="Supply Data" :data="supplyArray"></DataCard>
        <DataCard title="Price Data" :data="priceArray"></DataCard>
        <DataCard title="ROI Data" :data="roiArray"></DataCard>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <DataCard title="Uniswap Data" :data="uniswapArray"></DataCard>
        <DataCard title="Other Data" :data="otherArray"></DataCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" align-self="center" class="text-center justify-center">
        <div class="nomics-ticker-widget" data-name="Wise" data-base="WISE" data-quote="ETH" :data-theme="getNomicsTheme()"></div>
      </v-col>
      <v-col cols="6" align-self="center" class="text-center justify-center">
        <div class="nomics-ticker-widget" data-name="Wise" data-base="WISE" data-quote="USD" :data-theme="getNomicsTheme()"></div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VueTradingView style="height: 600px;" :options="{
          autosize: true,
          symbol: 'UNISWAP:WISEWETH',
          interval: '60',
          timezone: 'Etc/UTC',
          theme: 'dark',
          style: '1',
          locale: 'en',
          toolbar_bg: '#f1f3f6',
          enable_publishing: false,
          withdateranges: true,
          }" />
        </v-col>
      </v-row>
</v-container>


</template>

<script>
// import MarketData from "@/components/MarketData.vue";
  import PriceWidgetStaking from "@/components/PriceWidgetStaking.vue";
  import DataCard from "@/components/widgets/DataCard.vue";
  import NumberCard from "@/components/widgets/NumberCard.vue";
  import VueTradingView from 'vue-trading-view';

  import {
    mapState
  } from 'vuex';

  export default {
    name: "Price",
    components: {
      // MarketData,
      PriceWidgetStaking,
      DataCard,
      NumberCard,
      VueTradingView
    },
    created() {
      let nomicsWidgetScript = document.createElement('script');
      nomicsWidgetScript.setAttribute('src', 'https://widget.nomics.com/embed.js')
      document.head.appendChild(nomicsWidgetScript);
    },
    data() {
      return {
        help1: "Circulating supply times the current price",
        help2: "WISE on Uniswap + WISE in wallets + staked WISE",
        help3: "Return on Investment since the launch price",
        help4: "Total Liquidity on Uniswap and the rank of the WISE/ETH pair on Uniswap based on the total liquidity. See also https://info.uniswap.org/pairs",
        uniswapLiquidity: 0,
        uniswapRank: 0,
        totalMarketcapUSD: 0,
        totalMarketcapETH: 0,
        totalSupply: 0,
        roiUSD: 0,
        roiETH: 0,
        initialWISE: 260760440.016238701274314313,
        initialETH: 55900.80344143941383017,
        initialPriceETH: 55900.80344143941383017 / 260760440.016238701274314313,
        initialPriceUSD: 55900.80344143941383017 / 260760440.016238701274314313 * 747.35,
        currentPriceETH: 0,
        currentPriceUSD: 0,

        currentLiquidityRank: 0,
        currentLiquidityUSD: 0,

        currentPriceFloorUSD: 0,
        currentPriceFloorETH: 0,
        currentPriceFloorChange: 0,
        netPosBuysUSD: 0,
        netPosBuysETH: 0,
        totalTradingVolumeUSD: 0,
        totalTradingFeesUSD: 0,
        stakingDays: 0,
        coingeckoStatsObject: {},
        coingeckoStatsAvailable: false,
      }
    },
    computed: {
      marketUSDArray: function() {
        return this.getMarketUSDArray();
      },
      marketETHArray: function() {
        return this.getMarketETHArray();
      },
      supplyArray: function() {
        return this.getSupplyArray();
      },
      priceArray: function() {
        return this.getPriceArray();
      },
      roiArray: function() {
        return this.getRoiArray();
      },
      uniswapArray: function() {
        return this.getUniswapArray();
      },
      otherArray: function() {
        return this.getOtherArray();
      },
      ...mapState({
        currentUniswapStats: state => state.currentUniswapStats,
        currentETHPrice: state => state.currentETHPrice,
        // totalSupply: state => state.totalSupply,
        totalStaked: state => state.totalStaked,
        uniswapBalance: state => state.uniswapBalance,
        currentWiseDay: state => state.currentWiseDay,
        coingeckoStats: state => state.coingeckoStats
      }),
    },
    mounted() {
      this.updateAllCards();
      this.updateStakingDays();
      this.updateMarketData();
    },
    methods: {
      getNomicsTheme() {
        return this.$vuetify.theme.dark ? "dark" : "light";
      },
      updateAllCards() {
        this.updateCard1();
        this.updateCard2();
        this.updateCard3();
        this.updateCard4();
      },
      isDataFetchedCard1() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard2() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard3() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard4() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      updateCard1() {
        if (this.isDataFetchedCard1()) {
          this.currentPriceETH = this.$store.state.currentUniswapStats.priceETH;
          this.currentPriceUSD = this.$store.state.currentETHPrice * this.$store.state.currentUniswapStats.priceETH;
          this.circulatingSupply = (this.$store.state.totalSupply - this.$store.state.uniswapBalance + this.$store.state.totalStaked);
          this.totalMarketcapUSD = this.circulatingSupply * this.currentPriceUSD;
          this.totalMarketcapETH = this.circulatingSupply * this.currentPriceETH;
        }
      },
      updateCard2() {
        if (this.isDataFetchedCard2()) {
          this.value2 = 0;
        }
      },
      updateCard3() {
        if (this.isDataFetchedCard3()) {
          this.value3 = 0;
        }
      },
      updateCard4() {
        if (this.isDataFetchedCard4()) {
          this.value4 = 0;
        }
      },
      isDataFetched() {
        return (
          this.$store.state.currentETHPrice > -1 &&
          this.$store.state.currentUniswapStats.priceETH > -1 &&
          this.$store.state.currentUniswapStats.liquidityETH > -1 &&
          this.$store.state.currentUniswapStats.rank > -1 &&
          // this.$store.state.uniswapTrading.totalVolumeUSD > 0 &&
          this.$store.state.totalSupply > -1 &&
          this.$store.state.totalStaked > -1 &&
          this.$store.state.uniswapBalance > -1
        );
      },
      updateMarketData() {
        if (this.isDataFetched()) {
          this.totalSupply = this.$store.state.totalSupply + this.$store.state.totalStaked;
          this.currentPriceETH = this.$store.state.currentUniswapStats.priceETH;
          this.currentPriceUSD = this.$store.state.currentETHPrice * this.$store.state.currentUniswapStats.priceETH;
          this.circulatingSupply = (this.$store.state.totalSupply - this.$store.state.uniswapBalance + this.$store.state.totalStaked);
          this.maxSupply = (this.$store.state.totalSupply + this.$store.state.totalStaked);
          this.totalMarketcapUSD = this.circulatingSupply * this.currentPriceUSD;
          this.totalMarketcapETH = this.circulatingSupply * this.currentPriceETH;
          this.updateUniswapData();
        }
      },
      updateUniswapData() {
        // if (this.isDataFetched()) {
        this.currentLiquidityETH = this.$store.state.currentUniswapStats.liquidityETH;
        this.currentLiquidityUSD = this.$store.state.currentUniswapStats.liquidityETH * this.$store.state.currentETHPrice;
        this.currentLiquidityRank = this.$store.state.currentUniswapStats.rank;
        this.currentPriceFloorUSD = this.getCurrentPriceFloorUSD();
        this.currentPriceFloorETH = this.getCurrentPriceFloorETH();
        this.netPosBuysUSD = this.getCurrentNetPosBuysUSD();
        this.netPosBuysETH = this.getCurrentNetPosBuysETH();
        this.totalTradingVolumeUSD = this.$store.state.currentUniswapStats.volumeUSD;
        this.totalTradingFeesUSD = this.$store.state.currentUniswapStats.volumeUSD * 0.003;
        // this.totalTradingVolumeUSD = this.$store.state.uniswapTrading.totalVolumeUSD;
        // this.totalFeesETH = this.$store.state.uniswapTrading.totalFeesETH;
        // this.totalFeesWISE = this.$store.state.uniswapTrading.totalFeesWISE;
        // }
      },
      getPriceArray() {
        let priceArray = [];
        priceArray.push({
          name: 'Total Marketcap',
          line1: this.$options.filters.toCurrency(this.totalMarketcapUSD, 0, "USD"),
          line2: this.$options.filters.toInt(this.totalMarketcapETH, 0, "ETH")
        })
        priceArray.push({
          name: 'Initial Price',
          line1: this.$options.filters.toCurrency(this.initialPriceUSD, 3, "USD"),
          line2: this.$options.filters.formatWISE(this.initialPriceETH, "a", 7, "ETH")
        })
        priceArray.push({
          name: 'Current Price',
          line1: this.$options.filters.toCurrency(this.currentPriceUSD, 3, "USD"),
          line2: this.$options.filters.formatWISE(this.currentPriceETH, "a", 7, "ETH")
        })
        return priceArray;
      },
      getMarketUSDArray() {
        let marketUSDArray = [];
        let stats = this.$store.state.coingeckoStats;
        marketUSDArray.push({
          name: 'Price Change 1h',
          line1: this.$options.filters.toInt(stats.change_1h_usd, 3, "%"),
          colored1: true
        });
        marketUSDArray.push({
          name: 'Price Change 24h',
          line1: this.$options.filters.toInt(stats.change_24h_usd, 3, "%"),
          colored1: true
        });
        marketUSDArray.push({
          name: 'Price Change 7d',
          line1: this.$options.filters.toInt(stats.change_7d_usd, 3, "%"),
          colored1: true
        });
        marketUSDArray.push({
          name: 'Price Change 14d',
          line1: this.$options.filters.toInt(stats.change_14d_usd, 3, "%"),
          colored1: true
        });
        marketUSDArray.push({
          name: 'Trading Volume 24h',
          line1: this.$options.filters.toCurrency(stats.vol_usd, 0, "USD"),
        });
        // this.marketUSDArray = marketUSDArray;
        return marketUSDArray;
      },
      getMarketETHArray() {
        let marketETHArray = [];
        let stats = this.$store.state.coingeckoStats;
        marketETHArray.push({
          name: 'Price Change 1h',
          line1: this.$options.filters.toInt(stats.change_1h_eth, 3, "%"),
          colored1: true
        });
        marketETHArray.push({
          name: 'Price Change 24h',
          line1: this.$options.filters.toInt(stats.change_24h_eth, 3, "%"),
          colored1: true
        });
        marketETHArray.push({
          name: 'Price Change 7d',
          line1: this.$options.filters.toInt(stats.change_7d_eth, 3, "%"),
          colored1: true
        });
        marketETHArray.push({
          name: 'Price Change 14d',
          line1: this.$options.filters.toInt(stats.change_14d_eth, 3, "%"),
          colored1: true
        });
        marketETHArray.push({
          name: 'Trading Volume 24h',
          line1: this.$options.filters.toInt(stats.vol_eth, 0, "ETH"),
        });
        return marketETHArray;
      },
      getSupplyArray() {
        let supplyArray = [];
        supplyArray.push({
          name: 'Circulating Supply',
          line1: this.$options.filters.toInt(this.circulatingSupply, 0, "WISE"),
        });
        supplyArray.push({
          name: 'Total Minted Supply',
          line1: this.$options.filters.toInt(this.totalSupply, 0, "WISE"),
        });
        return supplyArray;
      },
      getOtherArray() {
        let otherArray = [];
        otherArray.push({
          name: 'Holders',
          line1: this.$options.filters.toInt(this.$store.state.holders, 0, ""),
        });
        return otherArray;
      },
      getRoiArray() {
        let roiArray = [];
        let roiFactorUSD = this.currentPriceUSD / this.initialPriceUSD;
        let roiFactorETH = this.currentPriceETH / this.initialPriceETH;
        this.roiUSD = (roiFactorUSD - 1) * 100;
        this.roiETH = (roiFactorETH - 1) * 100;
        roiArray.push({
          name: 'ROI on initial price',
          line1: "USD: " + this.$options.filters.toInt(this.roiUSD, 2, "%"),
          line2: "ETH: " + this.$options.filters.toInt(this.roiETH, 2, "%"),
        });
        roiArray.push({
          name: 'Factor on initial price',
          line1: "USD: " + this.$options.filters.toInt(roiFactorUSD, 2, "x"),
          line2: "ETH: " + this.$options.filters.toInt(roiFactorETH, 2, "x"),
        });
        return roiArray;
      },
      getUniswapArray() {
        let uniswapArray = [];
        uniswapArray.push({
          name: 'Liquidity',
          line1: this.$options.filters.toCurrency(this.currentLiquidityUSD, 0, "USD"),
          line2: this.$options.filters.toInt(this.currentLiquidityETH, 0, "ETH"),
        });
        uniswapArray.push({
          name: 'Liquidity Rank',
          line1: this.currentLiquidityRank
        });
        uniswapArray.push({
          name: 'Price Floor',
          line1: this.$options.filters.formatWISE(this.currentPriceFloorUSD, "a", 3, "USD"),
          line2: this.$options.filters.formatWISE(this.currentPriceFloorETH, "a", 7, "ETH"),
        });
        uniswapArray.push({
          name: 'Price Floor Percentage',
          line1: (this.currentPriceFloorChange * 100).toFixed(2) + "%",
        });
        uniswapArray.push({
          name: 'Total Net Positive Buys',
          line1: this.$options.filters.toCurrency(this.netPosBuysUSD, 0, "USD"),
          line2: this.$options.filters.formatWISE(this.netPosBuysETH, "", 0, "ETH"),
        });
        uniswapArray.push({
          name: 'Total Trading Volume	',
          line1: this.$options.filters.toCurrency(this.totalTradingVolumeUSD, 0, "USD"),
          line2: this.$options.filters.formatWISE(this.totalTradingVolumeUSD / this.$store.state.currentETHPrice, "", 0, "ETH"),
        });
        uniswapArray.push({
          name: 'Avg. Daily Trading Volume',
          line1: this.$options.filters.toCurrency(this.totalTradingVolumeUSD / this.stakingDays, 0, "USD"),
          line2: this.$options.filters.toInt(this.totalTradingVolumeUSD / this.$store.state.currentETHPrice / this.stakingDays, 0, "ETH"),
        });
        uniswapArray.push({
          name: 'Total Fees Generated',
          line1: this.$options.filters.toCurrency(this.totalTradingFeesUSD, 0, "USD"),
          line2: this.$options.filters.toInt(this.totalTradingFeesUSD / this.$store.state.currentETHPrice, 0, "ETH"),
        });
        uniswapArray.push({
          name: 'Pooled ETH',
          line1: this.$options.filters.toInt(this.$store.state.currentUniswapStats.tokensETH, 0, "ETH"),
        });
        uniswapArray.push({
          name: 'Pooled WISE',
          line1: this.$options.filters.toInt(this.$store.state.currentUniswapStats.tokensWISE, 0, "WISE"),
        });
        return uniswapArray;
      },
      getCurrentPriceFloorPercentage() {
        let uniswapWISE = parseFloat(this.$store.state.currentUniswapStats.tokensWISE);
        let liquidWISE = parseFloat(this.$store.state.totalSupply - this.$store.state.uniswapBalance);
        let percentage = uniswapWISE ** 2 / (uniswapWISE + liquidWISE) ** 2;
        this.currentPriceFloorChange = percentage - 1;
        return percentage;
      },
      getCurrentPriceFloorETH() {
        let percentage = this.getCurrentPriceFloorPercentage();
        return this.currentPriceETH * percentage;
      },
      getCurrentPriceFloorUSD() {
        return this.getCurrentPriceFloorETH() * this.$store.state.currentETHPrice;
      },
      getCurrentNetPosBuysUSD() {
        return this.getCurrentNetPosBuysETH() * this.$store.state.currentETHPrice;
      },
      getCurrentNetPosBuysETH() {
        return this.$store.state.currentUniswapStats.tokensETH - this.initialETH;
      },
      updateStakingDays() {
        this.stakingDays = this.$store.state.currentWiseDay - 51;
      }
    },
    watch: {
      currentUniswapStats() {
        this.updateMarketData();
        this.getRoiArray();
      },
      currentETHPrice() {
        this.updateMarketData();
      },
      totalSupply() {
        this.updateMarketData();
      },
      totalStaked() {
        this.updateMarketData();
      },
      uniswapBalance() {
        this.updateMarketData();
      },
      currentWiseDay() {
        this.updateStakingDays();
      },
      coingeckoStats() {
        // this.updatePriceData();
      }
    },
  }
</script>

<style lang="css" scoped>
</style>
